import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  copyButton: {
    padding: theme.spacing(1),
    minWidth: 40,
    marginRight: -14,
  },
}));
